import { render } from "./CalendarLg.vue?vue&type=template&id=07ea40e5"
import script from "./CalendarLg.vue?vue&type=script&lang=js"
export * from "./CalendarLg.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__